import Helpers from '@helpers';

const timer = () => {

    document.addEventListener('DOMContentLoaded', function () {
        const specialValid = document.getElementById('divSpecialRibbon');
        if (specialValid) {
            if (specialValid.dataset.timestamp) {
                const entryTime = new Date();
                var time = setInterval(() => {


                    const spanRemainingTime = document.getElementById('ribbonTime');

                    const expireTimestamp = Helpers.Utils.zeroIfEmpty(specialValid.dataset.timestamp);
                    const currentTime = new Date();
                    const passTime = (currentTime.getTime() - entryTime.getTime()) / 1000;
                    const expireTimeSeconds = expireTimestamp / 1000;
                    const remainingSeconds = (expireTimeSeconds - passTime);

                    var date = new Date(remainingSeconds * 1000);
                    date.setMinutes(date.getMinutes() - 210);
                    var hours = date.getHours();
                    var minutes = "0" + date.getMinutes();
                    var seconds = "0" + date.getSeconds();

                    var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

                    spanRemainingTime.textContent = formattedTime;

                }, 1000);
            }
        }
        

    })

}

export {
    timer
}